import { Flex, Switch, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { Form } from "@/organisms/Form"
import { CardTemplate } from "@/pages/GovernancePage/components/pages/AiPolicyPage/components/CardTemplate"

import type { EnforcementSectionProps } from "./EnforcementSection.types"

// The section the policy page and its form show under this title
export const ENFORCEMENT_SECTION_ID = "enforcement"

// What a real policy does to the calls its rules match: monitor or block them.
// Each rule sets the access its tools may not make. The page around it gives
// it its title.
export const EnforcementSection = ({ policy }: EnforcementSectionProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.live.form.enforcement"
  })
  const { form } = Form.useForm()
  const enforce = Form.useWatch("enforce", form)

  return (
    <Flex vertical gap={14}>
      <Text type="secondary">{t("description")}</Text>
      <CardTemplate type="notAllow">
        {policy ? (
          <Flex vertical gap={6} flex={1}>
            <Text>{t(policy.action === "BLOCK" ? "block" : "monitor")}</Text>
          </Flex>
        ) : (
          <Flex vertical gap={12} flex={1}>
            <Flex vertical gap={4}>
              <Flex gap={10} align="center">
                <Form.Item noStyle name="enforce" valuePropName="checked">
                  <Switch size="small" aria-label={t("enforce")} />
                </Form.Item>
                <Text>{t("enforce")}</Text>
              </Flex>
              <Text type="secondary" className="sm-text-ks">
                {t(enforce ? "enforceOnHelp" : "enforceHelp")}
              </Text>
            </Flex>
          </Flex>
        )}
      </CardTemplate>
    </Flex>
  )
}
